<template>
  <ModalUi @closeModal="toMainPage">
    <div class="modal-wrap">
      <div class="modal-block" :class="isCrmCourierChosen ? 'small' : null">
        <div class="modal-title">
          <h3>
            {{ orderCreatedMessage }}
            <div class="checkbox-container">
              <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z"
                  stroke="#3da35a"
                  fill="transparent"
                />
              </svg>
            </div>
          </h3>
        </div>
        <button class="close" type="button" @click="toMainPage"></button>
        <div class="modal-body" v-if="isInitialServices">
          <div class="body-block second" v-if="!base.isAdmin">
            <template v-if="!isCrmCourierChosen">
              <h5>Выберите дополнительные услуги для заказа:</h5>
              <div class="services-block">
                <div
                  class="service"
                  v-for="(service, index) in filteredUpsaleServices"
                  :key="service.id"
                  @click="toggleService(service.id)"
                  @keypress="toggleService(service.id)"
                >
                  <div class="round">
                    <input type="checkbox" :id="'checkbox' + index" :checked="service.isChecked" />
                    <label
                      :for="'checkbox' + index"
                      @click="toggleService(service.id)"
                      @keypress="toggleService(service.id)"
                    ></label>
                  </div>
                  <div
                    class="icon"
                    :style="{
                      backgroundColor: service.isChecked ? '#f13329' : '#868686',
                    }"
                  >
                    <i :class="`icon-${iconClasses[index]}`"></i>
                  </div>
                  <div class="service-block">
                    <div class="header">{{ service.name }} {{ service.price + ' ₽' }}</div>
                    <div class="description">{{ service.description }}</div>
                  </div>
                </div>
              </div>
              <button
                class="apply"
                :disabled="isLoading || !anyUpsaleChecked"
                :style="{
                  backgroundColor: anyUpsaleChecked ? '#dc3c24' : '#868686',
                }"
                @click="setServices"
                type="button"
              >
                {{ isLoading ? 'Загрузка' : 'Применить' }}
                <Spinner v-if="isLoading" margin-left />
              </button>
            </template>
            <download-apps />
          </div>
          <button
            v-if="base.isAdmin"
            class="apply"
            style="background-color: #dc3c24"
            @click="openOrder"
            type="button"
          >
            Открыть заказ
          </button>
        </div>
        <div v-else class="modal-body">
          <download-apps />
        </div>
      </div>
    </div>
  </ModalUi>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import ModalUi from '@features/UI/ModalUi.vue'
import qs from 'qs'
import generalStore, { GENERAL_STORE } from '@apps/order-form/src/store'
import Spinner from '@features/UI/FontAwesomeSpinner.vue'
import { HOME_ROUTE, ORDER_FORM_PAGES_LIST } from '@constants/cabinetRouter'
import downloadApps from './DownloadApps.vue'

export default {
  name: 'OrderCreatedModal',
  components: {
    downloadApps,
    ModalUi,
    Spinner,
  },
  data: () => ({
    iconClasses: ['mail', 'arrow-up', 'brush', 'phone'],
    isLoading: false,
    filteredUpsaleServices: [],
    initialRoute: null,
  }),
  computed: {
    ...mapState(GENERAL_STORE, [
      'orderCreatedMessage',
      'order',
      'base',
      'additional',
      'user',
      'modals',
      'services',
    ]),
    ...mapGetters(GENERAL_STORE, [
      'getUpsaleServices',
      'namedServices',
      'buildedOrder',
      'isCrmCourierChosen',
      'isAnonimousForm',
      'isOrderCreatedFromAnonimousForm',
    ]),
    anyUpsaleChecked() {
      return !!this.filteredUpsaleServices.find(service => service.isChecked)
    },
    isInitialServices() {
      return !!this.filteredUpsaleServices.length
    },
    isDeliveryWithoutContract() {
      return !this.namedServices.d_without_pact.isChecked
    },
  },
  methods: {
    ...mapMutations(GENERAL_STORE, [
      'toggleService',
      'setWarningMessage',
      'toggleModals',
      'setOrderCreatedMessage',
      'setOrderID',
      'createServices',
      'setAdditionalProps',
      'setBaseProps',
      'setOrderProps',
      'resetState',
    ]),
    toMainPage() {
      this.$store.commit('setStateIsOrderCreatedModal', false, { root: true })

      if (this.additional.isApp) {
        window.location = 'http://app.redirect/shopMyOrders'
      } else if (this.$router) {
        this.$router.push({ name: HOME_ROUTE })
      } else {
        window.location = '/'
      }
    },
    async setServices() {
      this.isLoading = true

      if (!this.anyUpsaleChecked) {
        this.isLoading = false
        return
      }

      let data = {
        orderId: this.order.id,
        alias: this.filteredUpsaleServices.flatMap(service =>
          service.isChecked ? [service.alias] : []
        ),
      }

      data = qs.stringify(data)

      try {
        const response = await axios.post('/ajax/orderList/addServicesFast', data, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            'X-Requested-With': 'XMLHttpRequest',
          },
        })

        if (!response.data.success) {
          this.setWarningMessage({
            body: response.data.errorText,
          })
          this.toggleModals('warningMessage')
        }

        if (this.base.isAdmin && this.base.isEdit) {
          window.location.href = `/admin/order/edit/${this.order.id}`

          return
        }

        this.toMainPage()
      } catch (e) {
        this.setWarningMessage({
          body: e,
        })
        this.toggleModals('warningMessage')
      } finally {
        this.isLoading = false
      }
    },
    openOrder() {
      window.location.href = `/admin/order/edit/${this.order.id}`
    },
  },
  created() {
    // beforeDestroy и destroyed сработают уже после роутинга, нужно зафиксировать на какой странице отобразилась модалка
    if (this.$route) this.initialRoute = this.$route?.name
    if (!this.$store.hasModule(GENERAL_STORE))
      this.$store.registerModule(GENERAL_STORE, generalStore)

    if (localStorage.getItem('savedOrder')) {
      const savedOrder = JSON.parse(localStorage.getItem('savedOrder'))

      this.setOrderCreatedMessage(savedOrder.orderMessage)
      this.createServices(savedOrder.services)
      this.setBaseProps(savedOrder.base)
      this.setAdditionalProps(savedOrder.additional)
      this.setOrderProps(savedOrder.order)
      this.$store.commit('setStateIsOrderFromAnonimousForm', true, { root: true })
      localStorage.removeItem('savedOrder')
    }
  },
  mounted() {
    const checkmark = document.querySelector('svg')
    const className = 'animate'

    this.filteredUpsaleServices = this.getUpsaleServices.filter(el => !el.isChecked)

    if (!checkmark.classList.contains(className)) {
      checkmark.classList.add(className)
    }
  },
  beforeDestroy() {
    // Убираем модуль GENERAL_STORE на любой странице кроме страницы формы в кабинете, там за удаление модуля отвечает страница OrderPage
    if (
      this.$store.hasModule(GENERAL_STORE) &&
      !ORDER_FORM_PAGES_LIST.includes(this.initialRoute)
    ) {
      this.resetState()
      this.$store.unregisterModule(GENERAL_STORE)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@assets/scss/fonts/peshkariki';
@import '@assets/orderForm/components/modals';

.apply {
  margin-top: 20px;
}

.pay-attention {
  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
}

.info-text {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-around;
}

button:disabled {
  cursor: default;

  background-color: #868686 !important;
}

.close {
  position: absolute;
  top: 12px !important;
  right: 12px !important;

  width: 18px !important;
  height: 18px !important;

  font-size: 20px !important;
  color: #fff !important;
  color: black !important;

  background-color: transparent !important;
  border: none !important;
  border-radius: 50% !important;

  transition: background-color 0.4s ease-out !important;

  &::before {
    content: '\ea0f';

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-52%, -45%);

    font-family: PeshkarikiFont, sans-serif !important;
    font-size: 20px;
  }

  &:hover {
    background-color: #787a7c;
  }
}

h3 {
  font-size: 20px !important;
}

.icon-phone::before {
  content: '\e942';

  position: relative;
  top: 0;
  left: 0;
  transform: translate(0, 0);

  font-family: PeshkarikiFont, sans-serif !important;
}

.icon-arrow-up::before {
  content: '\ea32';

  font-family: PeshkarikiFont, sans-serif !important;
}

.icon-mail::before {
  content: '\e945';

  font-family: PeshkarikiFont, sans-serif !important;
}

.icon-brush::before {
  content: '\e905';

  font-family: PeshkarikiFont, sans-serif !important;
}

.modal-title {
  display: flex;
  align-items: center;
  justify-content: center;

  margin-bottom: 30px !important;
  padding: 0 30px;
}

.service {
  cursor: pointer;

  display: flex;
  align-items: center;

  margin-bottom: 10px;

  .round {
    position: relative;

    margin-right: 20px;

    label {
      cursor: pointer;

      position: absolute;
      top: 0;
      left: 0;

      width: 20px;
      height: 20px;

      background-color: #fff;
      border: 1px solid #868686;
      border-radius: 50%;

      &::after {
        content: '';

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -60%) rotate(-45deg);

        width: 10px;
        height: 6px;

        opacity: 0;
        border: 2px solid #fff;
        border-top: none;
        border-right: none;
      }
    }

    input[type='checkbox'] {
      visibility: hidden;
    }

    input[type='checkbox']:checked + label {
      background-color: #f13329;
      border-color: #f13329;
    }

    input[type='checkbox']:checked + label::after {
      opacity: 1;
    }
  }

  .icon {
    display: flex;
    align-items: center;
    align-self: center;
    justify-content: center;

    width: 50px;
    min-width: 50px;
    height: 50px;
    margin-right: 20px;

    color: #fff !important;

    background-color: #868686;
    border-radius: 50%;

    transition: all 0.3s ease-out;

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        background-color: #bb2e25 !important;
      }
    }
  }

  .service-block {
    display: flex;
    flex-direction: column;

    max-width: 75%;

    .header {
      margin-bottom: 5px;

      font-weight: 700;
    }
  }
}

.services-block {
  margin-top: 35px;
}

.apps {
  margin-top: 20px;
}

.apps .apps-icons {
  display: flex;
  justify-content: space-around;
  @media (max-width: 360px) {
    a img {
      max-width: 115px;
    }
  }
}

.modal-block {
  overflow-y: auto;

  max-height: 83vh;
  @media (max-width: 768px) {
    border-radius: initial !important;
  }
}

.modal-body {
  display: flex;
  justify-content: center;

  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
}

.body-block {
  // max-width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  padding: 5px;
  padding: 0 50px;

  font-size: 16px;
  font-weight: 400;

  // &:first-child {
  //   border-right: 1px solid rgb(214, 191, 191);
  // }

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0;

    &:first-child {
      border-right: none;
    }
  }
}

h5 {
  font-size: 16px;
  font-weight: 700;
  text-align: left;
}

button {
  display: flex;
  align-items: center;
  justify-content: center;

  height: 35px;
  padding: 0 12px;

  color: #fff;

  background-color: #868686;
  border: none;
  border-radius: 5px;

  &.start {
    background-color: #dc3c24;

    @media (max-width: 768px) {
      margin-top: 20px;
    }
  }
}

::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

// chekmark styles

.checkbox-container {
  display: inline-block;

  width: 25px;
  height: 25px;

  vertical-align: bottom;
}

svg {
  width: 100%;
  height: 100%;
}

path {
  fill: #3da35a;
  stroke-dasharray: 99.4758;
  stroke-dashoffset: -99.4758;
}

svg.animate path {
  opacity: 1;

  animation: 1.7s ease forwards draw;
}

@keyframes draw {
  0% {
    transform: translateY(0);

    fill: transparent;
    stroke-dashoffset: -99.4758;
  }

  35% {
    fill: transparent;
    stroke-dashoffset: 0;
  }

  60% {
    transform: translateY(0);

    fill: #3da35a;
  }

  100% {
    fill: #3da35a;
    stroke-dashoffset: 0;
  }
}

[class^='icon-'],
[class*=' icon-'] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: PeshkarikiFont, sans-serif !important;
  font-weight: normal;
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-transform: none;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
